
import { CampaignFormData } from '../types';

interface CampaignMatch {
  id: string;
  score: number;
  campaign: any;
}

export const findMatchingCampaign = (
  formData: CampaignFormData,
  existingCampaigns: any[]
): CampaignMatch | null => {
  if (!existingCampaigns || existingCampaigns.length === 0) {
    return null;
  }

  const targetName = formData.core_issue_details.campaign_name?.toLowerCase().trim();
  const targetEntity = formData.core_issue_details.target_entity?.toLowerCase().trim();
  const targetIssue = formData.core_issue_details.political_issue?.toLowerCase().trim();

  if (!targetName || !targetEntity || !targetIssue) {
    return null;
  }

  let bestMatch: CampaignMatch | null = null;

  for (const campaign of existingCampaigns) {
    const campaignName = campaign.core_issue_details?.campaign_name?.toLowerCase().trim();
    const campaignEntity = campaign.core_issue_details?.target_entity?.toLowerCase().trim();
    const campaignIssue = campaign.core_issue_details?.political_issue?.toLowerCase().trim();

    if (!campaignName || !campaignEntity || !campaignIssue) {
      continue;
    }

    let score = 0;

    // Exact matches get highest score
    if (campaignName === targetName) score += 3;
    if (campaignEntity === targetEntity) score += 2;
    if (campaignIssue === targetIssue) score += 2;

    // Partial matches get lower score
    if (campaignName.includes(targetName) || targetName.includes(campaignName)) score += 1;
    if (campaignEntity.includes(targetEntity) || targetEntity.includes(campaignEntity)) score += 1;

    // Require at least campaign name + one other field to match
    if (score >= 4) {
      if (!bestMatch || score > bestMatch.score) {
        bestMatch = {
          id: campaign.id,
          score,
          campaign
        };
      }
    }
  }

  return bestMatch;
};

export const createCampaignFingerprint = (formData: CampaignFormData): string => {
  const name = formData.core_issue_details.campaign_name || '';
  const entity = formData.core_issue_details.target_entity || '';
  const issue = formData.core_issue_details.political_issue || '';
  
  return `${name}|${entity}|${issue}`.toLowerCase().replace(/\s+/g, ' ').trim();
};
